import React, { useContext } from 'react';
import { string } from 'prop-types';
import { OrderAPackageContext } from '../../OrderAPackageContext';
import { PackagePod } from '../packagePod/PackagePod';

export const PackagePodList = ({ storeId }) => {
  const { state } = useContext(OrderAPackageContext);
  const groups = new Map();

  [...state.products.values()].forEach((item) => {
    const { productGroup = '' } = item?.info || {};
    if (!groups.has(productGroup)) {
      groups.set(productGroup, [item]);
    } else {
      groups.set(productGroup, [...groups.get(productGroup), item]);
    }
  });
  const products = Array.from(groups.values()).flat();

  if (!products.length) return null;

  return (
    products
      .map((item, index) => (
        <PackagePod
          product={item}
          storeId={storeId}
          key={item.identifiers?.itemId}
          itemId={item.identifiers?.itemId}
          index={index}
        />
      ))
  );
};

PackagePodList.propTypes = {
  storeId: string.isRequired
};

PackagePodList.displayName = 'PackagePodList';
